import { useDispatch, useSelector } from "react-redux";
import { setToastData } from "../../features/toastSlice";

const useToast = () => {
  const dispatch = useDispatch();

  const toastData = useSelector((state) => state.toast.toastData);
  const toastType = useSelector((state) => state.toast.toastType);

  const showToast = ({ type, title, description }) =>
    dispatch(
      setToastData({
        type,
        data: {
          title,
          description,
        },
      })
    );
  return { toastData, toastType, showToast };
};

export default useToast;
